import * as React from 'react';
export const GISvg = React.forwardRef(function GISvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M1.994 2A1.991 1.991 0 0 0 0 3.998V10h16V3.998A1.997 1.997 0 0 0 14.006 2H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M14 2a2 2 0 0 1 2 2v6h-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v6H0V4a2 2 0 0 1 2-2h12Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 10v2c0 1.105.895 2 1.994 2h12.012A1.992 1.992 0 0 0 16 12v-2H0zm10-4V5h2v3H4V5h2v1h1V5h2v1h1z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F4B32E',
        d: 'M8.5 10.914V13h-1v-2.086L6.586 10 8 8.586 9.414 10l-.914.914Z',
      }),
    ),
  );
});
GISvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var GI = {
  category: 'flag',
  colorable: false,
  name: 'GI',
  svg: GISvg,
};
